module.exports = __webpack_public_path__ + "img/user-administration.e7068c86.png";